// extracted by mini-css-extract-plugin
export default {"container":"TextWithAvatar__container___biZcO"};